import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { fontSizeClass } from "@/domains/chat/constants/chat";

type Props = {
  show?: boolean;
  className?: string;
  fontSize: number;
};

const animations = {
  show: {
    opacity: 1,
  },
  hide: {
    opacity: 0,
  },
};

export default function MessageIsCopied({ show, className, fontSize }: Props) {
  const { t } = useTranslation("chat");

  return (
    <motion.div
      initial={{ opacity: 0 }}
      variants={animations}
      animate={show ? "show" : "hidden"}
      className={clsx(
        "text-center px-4 py-2 text-white/70 font-medium rounded-[0.5rem]",
        "bg-gradient-to-r from-dark-900/80 to-dark-900/60",
        fontSizeClass[fontSize],
        className,
      )}
    >
      {t("chat.messageIsCopied")}
    </motion.div>
  );
}
